import React from "react"
import PropTypes from "prop-types"
import { Flex, Button, Upload } from "antd"
import { UploadOutlined } from "@ant-design/icons"
import { useTranslation } from "react-i18next"
import { spacings } from "themes/variables"
import styles from "../index.module.css"
import IconWithBg from "ui/IconWithBg"

/**
 * Upload area component for file uploads
 */
const UploadArea = ({ fileList, onBeforeUpload, onChange, customRequest }) => {
  const { t } = useTranslation()
  const { Dragger } = Upload

  return (
    <Dragger
      fileList={fileList}
      beforeUpload={onBeforeUpload}
      onChange={onChange}
      customRequest={customRequest}
      showUploadList={false}
      multiple
      accept=".doc,.docx,.pdf,.txt,.jpg,.jpeg"
      className={styles.uploadArea}
    >
      <Flex align="center" gap={spacings.XS}>
        <IconWithBg icon={<UploadOutlined />} />
        <Flex vertical flex={1} align="center">
          <Button type="link" className={styles.uploadButton}>
            {t("crewMember.licenses.upload")}
          </Button>
          <span className={styles.uploadHint}>
            {t("crewMember.licenses.uploadHint")}
          </span>
        </Flex>
      </Flex>
    </Dragger>
  )
}

UploadArea.propTypes = {
  fileList: PropTypes.array.isRequired,
  onBeforeUpload: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  customRequest: PropTypes.func.isRequired
}

export default UploadArea
